// @ts-strict-ignore
import { Dispatch } from 'redux';

import { Page as ApiPage } from 'api/cms';
import { PublicPage, fetchPage as apiFetchPublicPage } from 'api/website';

import { MainStoreErrorAction, setError } from './error';

// Types

export type MainStoreContentsState = {
  byUrl: Record<
    string,
    { type: string; content: PublicPage } & {
      state: 'SUCCESS' | 'NOT_FOUND' | 'FETCHING';
    }
  >;
};

type FetchPageRequestAction = {
  type: 'FETCH_PAGE_REQUEST';
  url: string;
};

type FetchPageSuccessAction = {
  type: 'FETCH_PAGE_SUCCESS';
  content: {
    content: ApiPage;
    type: string;
  };
  url: string;
};

type FetchPageFailureAction = {
  type: 'FETCH_PAGE_FAILURE';
  url: string;
};

export type MainStoreContentsAction =
  | FetchPageRequestAction
  | FetchPageSuccessAction
  | FetchPageFailureAction;

// Reducer

const defaultState = {
  byUrl: {},
};

export function contentsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreContentsState = defaultState,
  action: MainStoreContentsAction
) {
  switch (action.type) {
    case 'FETCH_PAGE_REQUEST':
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: { ...state.byUrl[action.url], state: 'FETCHING' },
        },
      };

    case 'FETCH_PAGE_SUCCESS': {
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: {
            ...state.byUrl[action.url],
            ...action.content,
            state: 'SUCCESS',
          },
        },
      };
    }

    case 'FETCH_PAGE_FAILURE': {
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: { ...state.byUrl[action.url], state: 'NOT_FOUND' },
        },
      };
    }

    default:
      return state;
  }
}

// Actions

const fetchPageRequest = (url: string): FetchPageRequestAction => ({
  type: 'FETCH_PAGE_REQUEST',
  url,
});

const fetchPageSuccess = (
  content: {
    content: ApiPage;
    type: string;
  },
  url: string
): FetchPageSuccessAction => ({
  type: 'FETCH_PAGE_SUCCESS',
  content,
  url,
});

const fetchPageFailure = (url: string): FetchPageFailureAction => ({
  type: 'FETCH_PAGE_FAILURE',
  url,
});

export const fetchPage =
  (pageUrl: string) =>
  (
    dispatch: Dispatch<MainStoreContentsAction | MainStoreErrorAction>,
    getState: () => { contents: MainStoreContentsState }
  ) => {
    const content = getState().contents.byUrl[pageUrl];

    if (!content) {
      dispatch(fetchPageRequest(pageUrl));
      apiFetchPublicPage(pageUrl)
        .then((fetchedPage) => {
          dispatch(
            fetchPageSuccess(
              {
                content: fetchedPage.data,
                type: fetchedPage.type,
              },
              pageUrl
            )
          );
        })
        .catch((e) => {
          if (e.statusCode === 404) {
            dispatch(fetchPageFailure(pageUrl));
          } else {
            dispatch(setError(e));
          }
        });
    }
  };
export const updatePage = fetchPageSuccess;
